export default {
  name: 'Approval Case |||| Approval Cases',
  subtitle: 'Pending approval cases for your role',
  list: {
    pendingApprovalsTitle: 'Pending Approvals',
    pendingApprovalsTitleSubtitle: 'Pending approval cases',
    completedApprovalsTitle: 'Completed Approvals',
    completedApprovalsTitleSubtitle: 'Completed approval cases',
    submittedAt: 'Submitted at',
    completedAt: 'Completed at',
    actionKey: 'Action type',
    actionName: 'Action type',
    object: 'Object',
    originator: 'Originator',
    claimedBy: 'Claimed by',
    status: 'Status',
    step: 'Step',
    stepsProgress: '%{completed} of %{total}',
    filters: {
      submittedFrom: 'Submitted from',
      submittedTo: 'Submitted to',
      completedFrom: 'Completed from',
      completedTo: 'Completed to',
      objectType: 'Object type',
      objectId: 'Object Id',
      objectIdHint: 'Select object type first',
      requestedById: 'Originator Identity Id',
      withAllQueue: 'All pending approvals',
      actionType: 'Action type',
      actionTypeOptions: {
        CREATE: 'New object',
        UPDATE: 'Update object',
        ATOMIC: 'Atomic action',
        TRANSACTION: 'Transaction',
      },
      status: 'Status',
      statusOptions: {
        APPROVED: 'Approved',
        REJECTED: 'Rejected',
        CANCELLED: 'Cancelled',
        FAILED: 'Failed',
      },
      claimed: 'Claimed',
      claimedOptions: {
        ANY: 'Any',
        ME: 'Assigned to me',
        UNCLAIMED: 'Not claimed',
        OTHER: 'Assigned to others',
      },
    },
  },
  aside: {
    submittedAt: 'Submitted at',
    expiresAt: 'Expires at',
    completedAt: 'Completed at',
    actionType: 'Action type',
    status: 'Status',
    claimedBy: 'Claimed by',
    reason: 'Reason',
    loading: 'loading...',
  },
  tabs: {
    data: 'Data',
    cases: 'Cases For Object',
    casesForObject: 'Cases For Object',
  },
  show: {
    title: 'Approval Case for %{actionName}',
    titlePrefix: 'Approval Case for ',
    progress: 'Approval Progress',
    approvalsRequired: 'Step %{completed} out of %{total}',
    viewCase: 'View case',
    submitted: 'Submitted',
    completed: 'Completed',
    awaitingDecision: 'Awaiting decision',
    approvedBy: 'Approved by',
    rejectedBy: 'Rejected by',
    showMore: 'Show more',
    hide: 'Hide',
    actions: 'Actions',
    approve: 'APPROVE CASE',
    reject: 'REJECT CASE',
    claim: 'ASSIGN CASE TO ME',
    unclaim: 'UNASSIGN CASE FROM ME',
    cancel: 'CANCEL CASE',
    note: 'Note',
    approveConfirmTitle: 'Approve case',
    rejectConfirmTitle: 'Reject case',
    cancelConfirmTitle: 'Cancel case',
    loading: 'loading...',
    processing: 'Processing...',
    result: {
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
      CANCELLED: 'Cancelled',
      FAILED: 'Failed',
      message: {
        APPROVED: 'The case has been approved. The requested action will be processed shortly.',
        REJECTED: 'The case has been rejected and the requested action will not proceed.',
        CANCELLED: 'The case has been successfully cancelled.',
        FAILED: 'The case execution has failed. Please review the error details below.',
      },
    },
    data: {
      objectData: 'Object data',
      objectDetails: 'Object details',
      actionDetails: 'Action details',
      field: 'Field',
      currentValue: 'Current value',
      newValue: 'New value',
      showOnlyChanges: 'Show only changes',
      showAll: 'Show all',
      parameter: 'Parameter',
      value: 'Value',
      noData: 'No data',
    },
  },
};
